import PropTypes from "prop-types";
import { useState } from "react";
import { Table } from 'semantic-ui-react';

import dataHelper from "../../helpers/dataHelper";

const MAX_TABLE_PAGE_CELLS_COUNT = 17;

const DataTableRow = ({
    activePollutant,
    pollutantName,
    pollutantValue,
    dataBreaks,
    selectedGridId,
    sectorName,
}) => {
    const isDisabled = pollutantValue === "" || pollutantValue === 0;
    const isActive = activePollutant !== "" && activePollutant === pollutantName;

    const { value, unit } = dataHelper.getOptimalPollutantValue(pollutantName, pollutantValue, sectorName);
    let className = "";
    if (isActive && selectedGridId) {
        const position = dataHelper.getPositionInRanges(pollutantValue, dataBreaks);
        className = `color-code-${position}`;
    }

    return (
        <Table.Row
            disabled={isDisabled} 
            active={isActive}
            key={pollutantName}
            className={className}
            textAlign="center"
        >
            <Table.Cell>{dataHelper.getOptimalPollutantName(pollutantName)}</Table.Cell>
            <Table.Cell>{value}</Table.Cell>
            <Table.Cell>{unit}</Table.Cell>
        </Table.Row>
    );
}

function getTableBodyData(data = {}, activePollutant, page = 1) {
    const maxPages = Math.ceil(Object.keys(data).length / MAX_TABLE_PAGE_CELLS_COUNT);

    const pollutantKeys = Object.keys(data);

    if (activePollutant) {
        const activePollutantIndex = pollutantKeys.indexOf(activePollutant);
        if (activePollutantIndex !== -1) {
            pollutantKeys.splice(activePollutantIndex, 1);
            pollutantKeys.unshift(activePollutant);
        }
    }
    const tableBodyData = pollutantKeys
        .slice((page - 1) * MAX_TABLE_PAGE_CELLS_COUNT, page * MAX_TABLE_PAGE_CELLS_COUNT)
        .reduce((accumulator, key) => {
            accumulator[key] = data[key];
            return accumulator;
        }, {});


    return { tableBodyData, maxPages };
}

const DataTable = ({
    data,
    activePollutant,
    breaks,
    selectedGridId,
    sector,
}) => {
    const [page, setPage] = useState(1);

    const { tableBodyData, maxPages } = getTableBodyData(data, activePollutant, page);

    if (maxPages && maxPages < page) {
        setPage(maxPages);
    }

    return (
        <Table compact sortable fixed>
            <Table.Header >
                <Table.Row textAlign="center">
                    <Table.HeaderCell width={3}>Polutant</Table.HeaderCell>
                    <Table.HeaderCell width={4}>Vrijednost</Table.HeaderCell>
                    <Table.HeaderCell width={2}>Jedinica</Table.HeaderCell>
                </Table.Row>
            </Table.Header>

            <Table.Body>
                {Object.keys(tableBodyData).map(
                    (key) => (
                    <DataTableRow
                        key={key}
                        activePollutant={activePollutant}
                        pollutantName={key}
                        pollutantValue={tableBodyData[key]}
                        dataBreaks={breaks}
                        selectedGridId={selectedGridId}
                        sectorName={sector}
                    />)
                )}
            </Table.Body>
        </Table>);
};

DataTable.propTypes = {
    data: PropTypes.object,
    activePollutant: PropTypes.string,
};

DataTable.defaultProps = {
    data: {},
    activePollutant: "",
};

export default DataTable;